import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/snotra_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-ca8aafdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-logo__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-logo__img",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "header-logo__label" }, "Snotra")
], -1))
const _hoisted_3 = { class: "header-logo__right" }

import NavigationItem from '@/common/components/snedson-material-components/navigation-item/navigation-item.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const switchToDarkTheme = () => {
    localStorage.setItem('theme', 'dark');
    document.documentElement.className = 'dark-theme';
};

const switchToLightTheme = () => {
    localStorage.removeItem('theme');
    document.documentElement.className = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(NavigationItem, {
          class: "header-logo__switcher",
          props: {
                        iconName: 'dark_mode',
                        title: 'Переключиться на темную тему',
                        selected: false,
                    },
          onClick: switchToDarkTheme
        }),
        _createVNode(NavigationItem, {
          class: "header-logo__switcher header-logo__switcher--dark",
          props: {
                        iconName: 'light_mode',
                        title: 'Переключиться на светлую тему',
                        selected: false,
                    },
          onClick: switchToLightTheme
        })
      ])
    ])
  ]))
}
}

})